import { Directive, ElementRef, HostListener } from '@angular/core';
/* eslint-disable */

@Directive({
  selector: 'button'
})
/* eslint-enable */
export class ButtonUnFocusDirective {

  constructor(private elementRef: ElementRef<HTMLButtonElement>) {
  }

  @HostListener('click', ['$event'])
  onClick(event: any) {
    this.elementRef.nativeElement.blur();
  }
}
